import React, { useEffect, useState } from "react";
import { BtnLoader, CaretRight } from "../../../../icons";
import ProfileImageComp from "../../../common/profile";
import {
  useAddFeedReactionMutation,
  useGetCommentsQuery,
} from "../../../../store/api/homeApi";
import Button from "../../../common/button";
import Comment from "./comment";
import ProfileBadgeAvatar from "../../../user/user-profile/profile-avatar";
import { getLocalStorage } from "../../../../helpers/storage";

const FeedComments = ({
  showComment,
  postData = {},
  handleCommets = {},
  deletedCommentInfo,
}: any) => {
  const [newComment, setNewComment] = useState("");
  const [commentsData, setCommentsData]: any = useState([]);
  const [replyCommentId, setReplyCommentId] = useState(null);
  const [reactionOffset, setreactionOffset] = useState(0);
  const [postId, setpostId] = useState<string>("");
  const user = JSON.parse(getLocalStorage("userData") || "{}");

  const [addFeedReaction, { isLoading }] = useAddFeedReactionMutation();
  const {
    data,
    isSuccess,
    isFetching: commentFetching,
    refetch,
  } = useGetCommentsQuery(
    {
      entityId: postId,
      reactionOffset: reactionOffset,
    },
    { refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    setpostId(postData?.id);
    setCommentsData([]);
  }, [postData]);

  useEffect(() => {
    handleCommentsStorage(data, reactionOffset === 0);
  }, [data]);

  useEffect(() => {
    if (deletedCommentInfo && deletedCommentInfo.postId === postId) {
      if (deletedCommentInfo.reactionType === "comment") {
        setCommentsData((prevData: any) => ({
          ...prevData,
          reactions: prevData?.reactions?.filter(
            (comment: any) => comment?.id !== deletedCommentInfo?.commentId,
          ),
        }));
      }
    }
  }, [deletedCommentInfo, postId]);

  const handleAddComment = async () => {
    if (newComment.length === 0) return;
    try {
      const bodyData = {
        type: "comment",
        data: { message: newComment },
      };
      const response = await addFeedReaction({
        activityId: postId,
        bodyData,
      }).unwrap();
      if (response.success) {
        setNewComment("");
        handleCommets();
        if (isSuccess) {
          handleCommentsStorage(data, true);
        }
        refetch();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCommentsStorage = (commentsData: any, isReset = false) => {
    if (isReset) {
      setCommentsData(commentsData?.data);
    } else {
      setCommentsData((prev: any) => {
        return {
          ...prev,
          reactions: [
            ...(prev?.reactions || []),
            ...(commentsData?.data?.reactions || []),
          ],
          is_end: commentsData?.data?.is_end || false,
        };
      });
    }
  };

  if (postData?.is_deleted) return null;

  return (
    <div
      className={`overflow-hidden transition-min-height duration-300 ease-in-out ${showComment ? "min-h-10 mt-5 border-t border-gray-300 pt-5" : "h-0"}`}
    >
      <div className="w-full">
        <div className="flex mb-4 w-full items-center justify-between">
          {user?.badge ? (
            <div className={`relative w-10 h-[40px] mr-2`}>
              <ProfileBadgeAvatar
                profileImage={user?.profile_picture}
                customDivClassName="absolute h-10 w-10 border-4 z-1"
                customImgClassName="h-[40px] w-[40px] absolute rounded-full p-[3px]"
                customIconDivClassName="absolute z-[120] -bottom-[5px] left-[15px]"
                customStyle1="w-[50px] h-[14px] absolute -bottom-2 z-[100] overflow-hidden"
                customStyle2="w-[200px] h-4  absolute top-3 z-10 -left-10 overflow-hidden"
                customStarWidth={10}
                customStarHeight={10}
                customStyle3="w-[34px] h-[34px]"
                badge={user?.badge}
              />
            </div>
          ) : (
            <ProfileImageComp
              imageUrl={user?.profile_picture}
              customClass="w-10 h-10"
              is_opc={user?.memberships?.is_opc}
            />
          )}
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            className="border border-gray-300 rounded-full w-[84%] p-2 px-4 outline-none resize-none"
            placeholder="Leave your comments..."
            rows={1}
            style={{
              overflow: "hidden",
              lineHeight: "20px",
              height: newComment ? "auto" : "20px",
              minHeight: "40px",
              maxHeight: "60px",
            }}
            onInput={(e) => {
              const target = e.target as HTMLTextAreaElement;
              target.style.height = newComment ? "auto" : "20px";
              const maxHeight = 80;
              target.style.height =
                Math.min(target.scrollHeight, maxHeight) + "px";
            }}
          />
          <Button
            isSubmitting={isLoading}
            onClick={handleAddComment}
            customClasses="bg-secondary-300 text-white w-10 h-10 rounded-full ml-2 flex items-center justify-center cursor-pointer"
          >
            <CaretRight />
          </Button>
        </div>
        {commentsData?.reactions?.map((comment: any) => (
          <Comment
            key={comment.id}
            commentData={comment}
            postId={postId}
            setReplyCommentId={setReplyCommentId}
            replyCommentId={replyCommentId}
            reply_count={comment.reply_count}
            deletedCommentInfo={deletedCommentInfo}
          />
        ))}
        {!commentsData?.is_end ? (
          <div
            className="w-full text-primary-900 font-semibold cursor-pointer mt-10 mb-5 flex justify-center"
            onClick={() => {
              setreactionOffset(commentsData?.reactions?.length || 0);
            }}
          >
            {commentFetching ? <BtnLoader /> : "Load more comments"}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FeedComments;
